export default __webpack_public_path__ + "b489387cef2cbfa8a074b1db7fecfd19.svg";